import './State.css'
import { useState, useEffect, useRef } from 'react'
import { FaUser, FaPersonBooth, FaGlobeAsia, FaHouseUser } from 'react-icons/fa'
import useInView from '../../component/useInView'
import AnimatedCounterInView from '../../component/AnimatedCounterInView'
import { Api } from '../../Api/Api'

// const sleep = ms => {
//   return new Promise(resolve => setTimeout(() => resolve(), ms))
// }


const State = () => {

  const [clients, setClients] = useState(0)
  const [visitor, setVisitor] = useState(0)
  const [countries, setCountries] = useState(0)
  const [house, setHouse] = useState(0)

  const ref = useRef(null)
  const inView = useInView(ref)




  useEffect(() => {
    (async () => {
      await fetch(`${Api}/views`)
        .then(res => {
          return res.json();
        }).then(resq => {
          setVisitor(resq.counter)
        })
    })();


    setClients(100)
    setCountries(10)
    setHouse(40)

    // console.log(clients)

  }, [inView, clients])



  return (
    <div className="stats" id="stats" ref={ref}>
      <h2>Our Awesome Stats</h2>
      <div className="container">
        <div className="box">
          <i><FaUser /></i>
          <AnimatedCounterInView finalValue={clients} duration={500} />
          <span className="text">Clients</span>
        </div>
        <div className="box">
          <i><FaPersonBooth /></i>
          <AnimatedCounterInView finalValue={visitor} duration={500} />
          <span className="text">Visitor</span>
        </div>
        <div className="box">
          <i><FaGlobeAsia /></i>
          <AnimatedCounterInView finalValue={countries} duration={1000} />
          <span className="text">Countries</span>
        </div>
        <div className="box">
          <i><FaHouseUser /></i>
          <AnimatedCounterInView finalValue={house} duration={2000} />
          <span className="text">House</span>
        </div>
      </div>
    </div>
  )
}

export default State